import Vue from 'vue';
import chartOfAccountsTransformer from './../../transformers/chartOfAccounts';
import all from './all';

const success = (data, resolve) => {
  all();
  resolve();
};

const failed = (errors, reject) => {
  if (errors.error && errors.error.code) {
    reject(errors.error);
    return;
  }
  reject(chartOfAccountsTransformer.fetch(errors));
};

export default data => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/chart_of_accounts', chartOfAccountsTransformer.send(data))
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/chartOfAccounts/store.js